import { render } from "./DC.vue?vue&type=template&id=0fc9df7a"
const script = {}
script.render = render

export default script